define('viewmodels/Weightings_Thresholds/OrganizationalLevelWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils, ObjGeneralSettings) {
        var title = 'OLWViewModel';

        var OLWViewModel = {
            activate: activate,
            title: title,
            attached: attached,
            detached: detached,
            ObjGeneralSettings: ObjGeneralSettings,
            appsecurity: appsecurity,
            ScreenName: ko.observable(),
            AssessmentType: ko.observable(),
            AssessmentTypeId: ko.observable(),
            RiskTypeTabClick: RiskTypeTabClick,
            RiskType: ko.observable(),
            OrganizationLevelTabClick: OrganizationLevelTabClick,
            GetOrganizationLevelDetails: GetOrganizationLevelDetails,
            OrganizationLevelList: ko.observableArray([]),
            SelectedOrganizationLevel: ko.observable(),
            GetSubOrganizationLevelDetails: GetSubOrganizationLevelDetails,
            SubOrganizationLevelList: ko.observableArray([]),
            SubOrganizationLevelTabClick: SubOrganizationLevelTabClick,
            SelectedSubOrganizationLevel: ko.observable(),
            CollapseAllTreeView: CollapseAllTreeView,
            AreaLeveljstree: ko.observableArray([]),
            AreasOrQuestions: ko.observableArray([]),
            BusinessUnits: ko.observableArray([]),
            OrganizationWeight: ko.observableArray([]),
            EditableAreaName: ko.observable(),
            EditableAreaTotal: ko.observable(),
            selectedAreaId: ko.observable(),
            weightingsTableTitle: ko.observable(),
            IsDeadNode: ko.observable(),
            RefreshWeights: RefreshWeights,
            setSelectedArea: setSelectedArea,
            EditArea: ko.observable(),
            checkCopyOver: checkCopyOver,
            saveWeights: saveWeights,
            EditAreaWeights: EditAreaWeights,
            downloadWeightings: downloadWeightings,
            SelectedOrgLevel: ko.observable(),
            uploadDownloadWeightings: uploadDownloadWeightings,
            uploadWeightingsDocument: uploadWeightingsDocument,
            AutoPopulateWeights: AutoPopulateWeights,
            BulkDownloadWeights: BulkDownloadWeights,
            BulkUploadWeights: BulkUploadWeights,
            downloadBulkUploadExcel: downloadBulkUploadExcel,
            BulkuploadOrganizationalWeightingsDocument: BulkuploadOrganizationalWeightingsDocument,
            PopulateWeights: PopulateWeights,
            WeightingsList: ko.observableArray([]),
            SurveyCategoryID: ko.observable(),
            TaxonomyLevels: ko.observable([]),
            GetTaxonomyLevels: GetTaxonomyLevels,
            SelectedOrganizationLevelText: ko.observable(),
            OrgLevelMapList: ko.observable([]),
            OrgLevelChange: OrgLevelChange,
            CurrentSelectedOrganizationLevel: ko.observable(),
            OrgLevelChangeClick: OrgLevelChangeClick,
            applyOrgLevelWeightings: applyOrgLevelWeightings,
            FreezeFlag: ko.observable(),
            ControlsAccess: ko.observable(false),
            hasChildNodes: ko.observable(false),
            decimalLimit: ko.observable(5),
            LocaleCheckFlag: ko.observable(false),
            UpperDecimalLimit: ko.observable(100.00000),
            LowerDecimalLimit: ko.observable(0.00000),
            radioSelectedOptionValue: ko.observable(),
            selectedSourceAreaLevel: ko.observable(),
            NavigationMenuHideShow: NavigationMenuHideShow,
        };

        return OLWViewModel;

        //#region ----Run Time Events----

        function activate() {
            try {
                var Id = OLWViewModel.appsecurity.getParameterByName('atype');
                OLWViewModel.AssessmentTypeId(Id);
                OLWViewModel.appsecurity.GetAssessmentNames().then(function () {
                    OLWViewModel.AssessmentType(OLWViewModel.appsecurity.GetAssessmentName(OLWViewModel.AssessmentTypeId())+" ");
                    OLWViewModel.ScreenName(OLWViewModel.AssessmentType() + ' ' + ((!OLWViewModel.LocaleCheckFlag() || OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrganizationalLevelWeightings') == -1) ? 'Organizational Level Weightings' : OLWViewModel.ObjGeneralSettings.LocalizedTextList()[OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OrganizationalLevelWeightings')].Name()));
                });

                if (OLWViewModel.ObjGeneralSettings === undefined || OLWViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((OLWViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || OLWViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && OLWViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    OLWViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (OLWViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || OLWViewModel.ObjGeneralSettings.LocalizedTextList() == null || OLWViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || OLWViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || OLWViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            OLWViewModel.LocaleCheckFlag(false);
                        else
                            OLWViewModel.LocaleCheckFlag(true);
                    });
                }
                else {
                    if (OLWViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || OLWViewModel.ObjGeneralSettings.LocalizedTextList() == null || OLWViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || OLWViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || OLWViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        OLWViewModel.LocaleCheckFlag(false);
                    else
                        OLWViewModel.LocaleCheckFlag(true);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: activate() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: detached() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        };

        function attached() {
            try {
                $("#divNavSwitch2").hide();
                $('#DetailsTab').hide();
                $($('.content li').get(0)).trigger('click');
                scrollableTabs();
                if (appsecurity.isConfigurationFreeze() === undefined) {
                    appsecurity.GetConfigurationFreezeFlag().then(function () {
                        if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                            OLWViewModel.ControlsAccess(true);
                        }
                        else {
                            OLWViewModel.ControlsAccess(false);
                        }
                    });
                }
                else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                    OLWViewModel.ControlsAccess(true);
                }
                else {
                    OLWViewModel.ControlsAccess(false);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: attached() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ----Click Events----

        function RiskTypeTabClick(data, event) {
            try {
                OLWViewModel.RiskType(event.currentTarget.id);
                GetOrganizationLevelDetails();
                if (event.currentTarget.id == 'INH') {
                    $('#CDR').removeClass('active');
                    $('#INH').addClass('active');
                }
                if (event.currentTarget.id == 'CDR') {
                    $('#INH').removeClass('active');
                    $('#CDR').addClass('active');
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' in RiskTypeTabClick() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function OrganizationLevelTabClick(data, event) {
            try {
                OLWViewModel.SelectedOrganizationLevel(data.OrgId);
                $('#' + data.OrgLevel).addClass('active').siblings().removeClass('active');
                GetSubOrganizationLevelDetails();
                //GetTaxonomyLevels();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' in OrganizationLevelTabClick() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function SubOrganizationLevelTabClick(data, event) {
            try {
                $('#mainLoader').show();
                $('#DetailsTab').hide();
                $('#' + data.SubOrgLevel).addClass('active').siblings().removeClass('active');
                OLWViewModel.SelectedOrgLevel(parseInt(data.SubOrgLevel));
                OLWViewModel.SelectedSubOrganizationLevel(data.SubOrgLevel);
                InitiateLevelTree();
                $("#spanExpandAllOW").text((!OLWViewModel.LocaleCheckFlag() || OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : OLWViewModel.ObjGeneralSettings.LocalizedTextList()[OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                $("#arrowSpanOW").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SubOrganizationLevelTabClick() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function OrgLevelChangeClick() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/GetOrgLevelWeightingsOnClick",
                    type: "GET",
                    headers: headers,
                    data: { "RiskAreaType": OLWViewModel.RiskType().toString(), "AssessmentType": OLWViewModel.AssessmentTypeId(), "AreaId": OLWViewModel.selectedAreaId(), "OrgLevel": OLWViewModel.SelectedSubOrganizationLevel(), "UpdatedOption": OLWViewModel.CurrentSelectedOrganizationLevel() }
                })
                    .success((jsonResult, success) => {
                        try {
                            if (jsonResult != null && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                            }
                            else
                                GetOrgLevelWeightings();
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: Success method in OrganizationalLevelWeightings.js';
                            logger.logMessage(msg);
                        }
                    })
                    .fail((error, status) => {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in in OrganizationalLevelWeightings.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OrgLevelChangeClick() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function nodeClickEvent(event, node) {
            try {
                OLWViewModel.selectedAreaId(node.id);
                OLWViewModel.weightingsTableTitle(node.text);
                OLWViewModel.IsDeadNode(node.dead_node);
                GetOrgLevelWeightings();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ----Tree Methods----

        function InitiateLevelTree() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {
                    url: "/api/WeightingsThresholds/GetRiskAreaStructure",
                    type: "GET",
                    data: { "RiskAreaType": OLWViewModel.RiskType().toString(), "AssessmentTypes": OLWViewModel.AssessmentTypeId().toString(), "ScreenType": 'W' },
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                $('#mainLoader').hide();
                $('#DetailsTab').show();

                if (jsonResult !== null) {
                    if (jsonResult.ErrorID == -99) {
                        logger.logError(jsonResult.Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                    else {
                        OLWViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);

                        var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                            return new jsTreeModel(result);
                        });

                        $('#jsTreeAreaLevel').treeview({
                            data: MappedJsTreeList,
                            onNodeSelected: nodeClickEvent
                        });
                    }
                }

                var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                OLWViewModel.hasChildNodes(hasChildNodes);

                $("#jsTreeAreaLevel ul:first li:first").trigger("click");
            }

            function filterJsTree(TreeStructure) {
                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes !== undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel === 1)
                            return true;
                        return false;
                    }
                );
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function CollapseAllTreeView() {
            if ($('#spanExpandAllOW').text() === ((!OLWViewModel.LocaleCheckFlag() || OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : OLWViewModel.ObjGeneralSettings.LocalizedTextList()[OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAllOW").text((!OLWViewModel.LocaleCheckFlag() || OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : OLWViewModel.ObjGeneralSettings.LocalizedTextList()[OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                $("#arrowSpanOW").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            else {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAllOW").text((!OLWViewModel.LocaleCheckFlag() || OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : OLWViewModel.ObjGeneralSettings.LocalizedTextList()[OLWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
                $("#arrowSpanOW").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        //#endregion

        //#region ----Navigation----

        function NavigationMenuHideShow(data) {
            try {
                if (data == "Hide") {
                    $('#HideNavMenuCntrl').hide();
                    $('#ShowNavMenuCntrl').show();
                    $('#FilterAreaAccordion').hide();
                    $("#tabContent").removeClass("col-lg-9").addClass("col-lg-12");
                }
                else {
                    $('#HideNavMenuCntrl').show();
                    $('#ShowNavMenuCntrl').hide();
                    $('#FilterAreaAccordion').show();
                    $("#tabContent").removeClass("col-lg-12").addClass("col-lg-9");
                }
                RestructureTables();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in NavigationMenuHideShow() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ----Get Methods----

        function GetOrgLevelWeightings() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/GetOrgLevelWeightings",
                    type: "GET",
                    headers: headers,
                    data: { "RiskAreaType": OLWViewModel.RiskType().toString(), "AssessmentType": OLWViewModel.AssessmentTypeId(), "AreaId": OLWViewModel.selectedAreaId(), "OrgLevel": OLWViewModel.SelectedSubOrganizationLevel() }
                })
                    .success((jsonResult, success) => {
                        try {
                            if (jsonResult != null & jsonResult.ErrorId == -99) {
                                logger.logError(jsonResult.Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                            }
                            else if (jsonResult !== null) {
                                OLWViewModel.BusinessUnits([]);
                                OLWViewModel.AreasOrQuestions([]);
                                OLWViewModel.OrganizationWeight([]);

                                OLWViewModel.decimalLimit(jsonResult.precisionObject);

                                OLWViewModel.UpperDecimalLimit(parseInt(OLWViewModel.UpperDecimalLimit()).toFixed(OLWViewModel.decimalLimit()));
                                OLWViewModel.LowerDecimalLimit(parseInt(OLWViewModel.LowerDecimalLimit()).toFixed(OLWViewModel.decimalLimit()));

                                if (jsonResult.OrgLevels.length > 0) {
                                    var mappedOrgLevelsData = $.map(jsonResult.OrgLevels, (result) => {
                                        return new OrganizationLevelModel(result);
                                    });

                                    OLWViewModel.OrgLevelMapList([]);
                                    OLWViewModel.OrgLevelMapList(mappedOrgLevelsData);
                                }

                                for (i = 0; i < jsonResult.FreezeModel.length; i++) {
                                    if (jsonResult.FreezeModel[i].Status == 1) {
                                        OLWViewModel.FreezeFlag(1);
                                        break;
                                    }
                                    else {
                                        OLWViewModel.FreezeFlag(0);
                                    }
                                }

                                for (var i = 0; i < jsonResult.OrgLevels.length; i++) {
                                    if (jsonResult.OrgLevels[i].PreviouslySelectedFlag == 1) {
                                        OLWViewModel.CurrentSelectedOrganizationLevel(jsonResult.OrgLevels[i].BlId);
                                        break;
                                    }
                                }

                                if (jsonResult.BUWiseWeightings.length > 0) {
                                    var mappedBusinessUnitData = $.map(jsonResult.BUWiseWeightings, (result) => {
                                        return new BusinessLevelsModel(result);
                                    });
                                    OLWViewModel.BusinessUnits([]);
                                    OLWViewModel.BusinessUnits(mappedBusinessUnitData);
                                }
                                OLWViewModel.AreasOrQuestions([]);
                                if (jsonResult.AreaWiseWeightings.length > 0) {
                                    var mappedAreasOrQuestions = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                        return new RiskAreaModel(result);
                                    });
                                    OLWViewModel.AreasOrQuestions([]);
                                    OLWViewModel.AreasOrQuestions(mappedAreasOrQuestions);
                                }
                                setSelectedArea(mappedAreasOrQuestions[0].AreaId());
                                OLWViewModel.OrganizationWeight([]);
                                if (jsonResult.WeightingsList.length > 0) {
                                    var mappedOrganizationWeight = $.map(jsonResult.WeightingsList, (result) => {
                                        return new WeightingsModel(result);
                                    });
                                    OLWViewModel.OrganizationWeight([]);
                                    OLWViewModel.OrganizationWeight(mappedOrganizationWeight);
                                }

                                let scrollHeight = "20rem";

                                if ($.fn.DataTable.isDataTable('#WeightingsTable')) {
                                    OLWViewModel.BusinessUnits([]);
                                    var tableObj = $('#WeightingsTable').DataTable();
                                    tableObj.fixedHeader.disable();
                                    tableObj.destroy();
                                    $('#WeightingsTable tbody tr').remove();
                                    $("#WeightingsTableHeader > th").remove();
                                    $("#WeightingsTableTotal > th").remove();
                                    var htmlHeader = '';
                                    if (OLWViewModel.IsDeadNode() === 1 && OLWViewModel.selectedAreaId() != "-999") {
                                        htmlHeader += '<th class="site_name Weightings-Fixed-Column">Business Units ↓ / Questions →</th> \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableAreaName">'+ OLWViewModel.EditableAreaName() + '</th>';
                                    }
                                    else {
                                        htmlHeader += '<th class="site_name Weightings-Fixed-Column" >Business Units → / Areas ↓</th> \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableAreaName">'+ OLWViewModel.EditableAreaName() + '</th>';
                                    }
                                    for (var i = 0; i < OLWViewModel.AreasOrQuestions().length; i++) {
                                        htmlHeader += '<th class="site_name header-ellipsis"><div style="display:flex"><label id=' + OLWViewModel.AreasOrQuestions()[i].AreaId() + ' title="' + OLWViewModel.AreasOrQuestions()[i].AreaName() + '">' + OLWViewModel.AreasOrQuestions()[i].AreaName() + '</label> &emsp; <icon class="fa fa-edit float-right float-top" title="Edit Weights" data-bind="click: $root.EditAreaWeights"></icon></div></th>';
                                    }

                                    $('#WeightingsTableHeader').html(htmlHeader);
                                    document.getElementById('WeightingsTableHeader').innerHTML = htmlHeader;
                                    ko.cleanNode(document.getElementById('WeightingsTableHeader'));
                                    ko.applyBindings(OLWViewModel, document.getElementById("WeightingsTableHeader"));
                                    var htmlFooter = '';
                                    htmlFooter = '<th  class="site_name">Total</th> <th class="text-center heatmap-grey" data-bind="css:{\'heatmap-red\' :($root.EditableAreaTotal()!=$root.UpperDecimalLimit()&&$root.EditableAreaTotal()!=$root.LowerDecimalLimit()),\'heatmap-grey\' : \'true\'}"> <span data-bind="text:$root.EditableAreaTotal" > ' + OLWViewModel.EditableAreaTotal() + '</span> <span> % </span> </th>';

                                    for (i = 0; i < OLWViewModel.AreasOrQuestions().length; i++) {
                                        if (Number(OLWViewModel.AreasOrQuestions()[i].total()).toFixed(OLWViewModel.decimalLimit()) != OLWViewModel.UpperDecimalLimit() && Number(OLWViewModel.AreasOrQuestions()[i].total()).toFixed(OLWViewModel.decimalLimit()) != OLWViewModel.LowerDecimalLimit()) {
                                            htmlFooter += '<th class="heatmap-red text-center " >' + OLWViewModel.AreasOrQuestions()[i].total() + ' % ' + '</th>';
                                        }
                                        else {
                                            htmlFooter += '<th class="heatmap-grey text-center" >' + OLWViewModel.AreasOrQuestions()[i].total() + ' % ' + '</th>';
                                        }
                                    }
                                    $('#WeightingsTableTotal').append(htmlFooter);
                                    document.getElementById('WeightingsTableTotal').innerHTML = htmlFooter;
                                    ko.cleanNode(document.getElementById('WeightingsTableTotal'));
                                    ko.applyBindings(OLWViewModel, document.getElementById("WeightingsTableTotal"));

                                    if (jsonResult.BUWiseWeightings.length > 0) {
                                        var mappedAandQ = $.map(jsonResult.BUWiseWeightings, (result) => {
                                            return new BusinessLevelsModel(result);
                                        });

                                        OLWViewModel.BusinessUnits(mappedAandQ);
                                        setSelectedArea(mappedAandQ[0].BUId());
                                    }
                                    tableObj = $('#WeightingsTable').DataTable(
                                        {
                                            'aoColumnDefs': [{
                                                'bSortable': false,
                                                "targets": "_all"
                                            }],
                                            "aaSorting": [],
                                            "scrollY": scrollHeight,
                                            "scrollX": true,
                                            "scrollCollapse": true,
                                            "paging": false,
                                            "bInfo": false,
                                            "bAutoWidth": false,
                                            fixedColumns: {
                                                leftColumns: 1
                                            },
                                            fixedheader: {
                                                header: true
                                            }
                                        }).draw();
                                }
                                else if (!$.fn.DataTable.isDataTable('#WeightingsTable')) {
                                    $('#WeightingsTable').DataTable(
                                        {
                                            'aoColumnDefs': [{
                                                'bSortable': false,
                                                "targets": "_all"
                                            }],
                                            "aaSorting": [],
                                            "scrollY": scrollHeight,
                                            "scrollX": true,
                                            "scrollCollapse": true,
                                            "paging": false,
                                            "bInfo": false,
                                            "bAutoWidth": false,
                                            fixedColumns: {
                                                leftColumns: 1
                                            },
                                            fixedheader: {
                                                header: true
                                            }
                                        });
                                }
                                $('#WeightingsTable tbody').scroll(function (e) {
                                    $('#WeightingsTable thead').css("left", -$("#WeightingsTable tbody").scrollLeft());
                                    $('#WeightingsTable thead th:nth-child(1)').css("left", $("#WeightingsTable tbody").scrollLeft());
                                    $('#WeightingsTable tbody td:nth-child(1)').css("left", $("#WeightingsTable tbody").scrollLeft());
                                });
                            }
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: GetOrgLevelWeightings() Success method in OrganizationalLevelWeightings.js';
                            logger.logMessage(msg);
                        }
                    })
                    .fail((error, status) => {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOrgLevelWeightings() method in OrganizationalLevelWeightings.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function GetOrganizationLevelDetails() {
            try {
                $.ajax({
                    url: "/api/Configuration/getAllDistinctBusinessLevels",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetOrganizationLevelDetails() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].Incident_Description != null && jsonResult[0].Incident_Description.substring(0, 3) == "INC") {
                        logger.logError(jsonResult[0].Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                    else if (jsonResult != null && jsonResult.length > 0) {
                        var MappedBUModelList = $.map(jsonResult, function (result) {
                            return new OrganizationModel(result);
                        });
                        OLWViewModel.OrganizationLevelList(MappedBUModelList);
                        $('#OrganizationLevelTab').tabs();
                        $('#OrganizationLevelTab').tabs('refresh');
                        $('#OrganizationLevelTab').tabs({ active: 0 });
                        $($('.sub-tabs-custom li').get(0)).trigger('click');
                        $($('.sub-tabs-custom li').get(0)).addClass('active');
                        scrollableTabs();
                    }
                    else {
                        app.showMessage("Organizational Levels configurations not in place", "Error", ["OK"]);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetOrganizationLevelDetails() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetOrganizationLevelDetails() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetSubOrganizationLevelDetails(data, event) {
            try {
                $.ajax({
                    url: "/api/WeightingsThresholds/getBusinessUnitLevelDetails",
                    data: { "levelid": OLWViewModel.SelectedOrganizationLevel() },
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetSubOrganizationLevelDetails() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].BuLevelDetailName != null) {
                        var mappedBULevelsList = $.map(jsonResult, function (result) {
                            return new SubOrganizationModel(result);
                        });
                        OLWViewModel.SubOrganizationLevelList(mappedBULevelsList);
                        $('#SubOrganizationLevelTab').tabs();
                        $('#SubOrganizationLevelTab').tabs('refresh');
                        scrollableTabs();
                        $('ul#SubOrgaLevelUl li:first').click();
                    }
                    else if (jsonResult != null && jsonResult.length > 0 && jsonResult[0].ErrorId == -99) {
                        logger.logError(jsonResult[0].ErrorName + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                    else
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSubOrganizationLevelDetails() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSubOrganizationLevelDetails() method in OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSubOrganizationLevelDetails() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetTaxonomyLevels() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {
                    url: "/api/WeightingsThresholds/GetTaxonomyLevel",
                    type: "GET",
                    data: { "SurveyCategoryID": null, "Show_Lowest_Level": 1 },
                    headers: headers
                };
                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyLevels() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult !== null) {
                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null && jsonResult[0].Incident_Description.substring(0, 3) == "INC") {
                        logger.logError(jsonResult[0].Incident_Description + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                    else {
                        OLWViewModel.TaxonomyLevels([]);
                        var MappedTaxonomyLevel = $.map(jsonResult, function (result) {
                            return new TaxonomyModel(result);
                        });
                        OLWViewModel.TaxonomyLevels(MappedTaxonomyLevel);
                    }
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTaxonomyLevels method in OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTaxonomyLevels method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function OrgLevelChange() {
            try {
                GetOrgLevelWeightings();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OrgLevelChange() method in AMLOrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RestructureTables() {
            try {
                GetOrgLevelWeightings();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in RestructureTables() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ----Set Method----

        function setSelectedArea(id) {
            try {
                for (var i = 0; i < OLWViewModel.AreasOrQuestions().length; i++) {
                    if (OLWViewModel.AreasOrQuestions()[i].AreaId() == id) {
                        OLWViewModel.EditArea(OLWViewModel.AreasOrQuestions()[i]);
                        break;
                    }
                }
                OLWViewModel.EditableAreaName(OLWViewModel.EditArea().AreaName());
                OLWViewModel.EditableAreaTotal(parseInt(OLWViewModel.EditArea().total()).toFixed(OLWViewModel.decimalLimit()));
                for (i = 0; i < OLWViewModel.BusinessUnits().length; i++) {
                    OLWViewModel.BusinessUnits()[i].selectedAreaWeight(OLWViewModel.EditArea().AreaWeightings[i].WeightingValue());
                    OLWViewModel.BusinessUnits()[i].Applicability(OLWViewModel.EditArea().AreaWeightings[i].Applicability());
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: setSelectedArea() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ----Upload/Download----

        function downloadWeightings(data, event) {
            try {
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), RiskAreaType: OLWViewModel.RiskType().toString(), AssessmentType: data.AssessmentTypeId(), AreaId: data.selectedAreaId(), OrgLevel: data.SelectedOrgLevel(), UpdatedOption: OLWViewModel.CurrentSelectedOrganizationLevel()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadExcelOrganizationalWeightings", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | downloadWeightings() in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function uploadDownloadWeightings(data, event) {
            try {
                $('#uploadDownloadWeightingsPopup').modal('show');
                document.getElementById('valfactorerror').innerHTML = "";
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: uploadDownloadWeightings() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function uploadWeightingsDocument(data, event) {
            try {
                var FileList = document.getElementById('FileUploader').files;
                if (FileList.length > 0) {
                    var FileName = document.getElementById('FileUploader').files[0].name;
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX' || FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM') {
                        if (FileList[0].size <= 1073741824) {
                            document.getElementById('valfactorerror').innerHTML = "";
                            var FormDataObj = new FormData();
                            FormDataObj.append("File1", FileList[0]);
                            var request = new XMLHttpRequest();

                            request.onreadystatechange = function () {
                                if (request.readyState == 1) {
                                    document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                    $('#valfactorerror').show();
                                }
                                else if (request.readyState == 4) {
                                    if (request.status == 200) {
                                        if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                            var DocName = document.getElementById('FileUploader').files[0].name;
                                            document.getElementById('FileUploader').value = null;
                                            if (request.responseText == "2" || request.responseText == "-1") {
                                                document.getElementById('valfactorerror').innerHTML = "Error in file upload";
                                                logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(OLWViewModel), true);
                                                $('#valfactorerror').show();
                                            }
                                            else {
                                                document.getElementById('valfactorerror').innerHTML = "The file has been uploaded successfully.";
                                                logger.logSuccess('File Uploaded Successfully', 'Success', system.getModuleId(OLWViewModel), true);
                                                $('#valfactorerror').show();
                                                GetOrgLevelWeightings();
                                            }
                                        }
                                        else {
                                            document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                            logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(OLWViewModel), true);
                                            $('#valfactorerror').show();
                                            document.getElementById('FileUploader').value = null;
                                        }
                                    }
                                    else
                                        ajaxFail(request, "");
                                }
                            };

                            request.upload.addEventListener('progress', function (event) {
                                document.getElementById('valfactorerror').innerHTML = "Uploading File...";
                            });
                            request.withCredentials = true;
                            request.open('POST', "/api/WeightingsThresholds/UploadOrganizationalLevelsWeightingsExcelTemplate?matId=" + OLWViewModel.selectedAreaId() + "&riskareatype=" + OLWViewModel.RiskType() + "&ratId=" + OLWViewModel.AssessmentTypeId() + "&OrgLevel=" + OLWViewModel.SelectedOrgLevel() + "&UpdatedOption=" + parseInt(OLWViewModel.CurrentSelectedOrganizationLevel()));
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            request.setRequestHeader('Authorization', headers.Authorization);
                            request.setRequestHeader('RT', headers.RT);
                            request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                            request.send(FormDataObj);
                        }
                        else {
                            document.getElementById('FileUploader').value = null;
                            logger.logError("Upload File Size cannot exceed " + (OLWViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.", 'Error', system.getModuleId(OLWViewModel), true);
                        }
                    }
                    else {
                        document.getElementById('FileUploader').value = null;
                        logger.logError('Please select valid File to Upload.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                }
                else {
                    document.getElementById('FileUploader').value = null;
                    logger.logError('Please select a File to Upload', 'Error', system.getModuleId(OLWViewModel), true);
                }
                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        router.navigate("survey/SurveyDashBoard", true);
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in uploadWeightingsDocument() method in OrganizationalLevelWeightings.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in uploadWeightingsDocument() method in OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in uploadWeightingsDocument() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BulkDownloadWeights(data, event) {
            try {
                $('#BulkDownloadPopup').modal('show');
                if (OLWViewModel.TaxonomyLevels() == undefined || OLWViewModel.TaxonomyLevels().length == 0)
                    GetTaxonomyLevels();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BulkDownloadWeights() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function downloadBulkUploadExcel(data, event) {
            try {
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), RiskAreaType: OLWViewModel.RiskType().toString(), AssessmentType: data.AssessmentTypeId(), AreaId: OLWViewModel.selectedTaxonomyLevel, OrgLevel: data.SelectedOrgLevel()
                };

                utils.postAndRedirect(rootPath + "/FileDownload/DownloadBulkUploadOrganizationalWeightingsTemplate", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | downloadBulkUploadExcel Source | () in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BulkUploadWeights() {
            try {
                $('#uploadBulkWeightingsPopup').modal('show');
                document.getElementById('valfactorerrorbulkupload').innerHTML = "";
                if (OLWViewModel.TaxonomyLevels() == undefined || OLWViewModel.TaxonomyLevels().length == 0)
                    GetTaxonomyLevels();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BulkUploadWeights() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BulkuploadOrganizationalWeightingsDocument(data, event) {
            try {
                app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please Deny. </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {
                            var FileList = document.getElementById('FileUploaderBulkUpload').files;
                            if (FileList.length > 0) {
                                var FileName = document.getElementById('FileUploaderBulkUpload').files[0].name;
                                var ExtensionCheck = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase();
                                if (ExtensionCheck == 'XLSX' || ExtensionCheck == 'XLSM') {
                                    if (FileList[0].size <= 1073741824) {
                                        document.getElementById('valfactorerrorbulkupload').innerHTML = "";
                                        var FormDataObj = new FormData();
                                        FormDataObj.append("File1", FileList[0]);
                                        var request = new XMLHttpRequest();

                                        request.onreadystatechange = function () {
                                            if (request.readyState == 1) {
                                                document.getElementById('valfactorerrorbulkupload').innerHTML = "Initializing File Upload...";
                                                $('#valfactorerrorbulkupload').show();
                                            }
                                            else if (request.readyState == 4) {
                                                if (request.status == 200) {
                                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                        var DocName = document.getElementById('FileUploaderBulkUpload').files[0].name;
                                                        document.getElementById('FileUploaderBulkUpload').value = null;
                                                        if (request.responseText == "2" || request.responseText == "-1") {
                                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "Error in file upload";
                                                            logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(OLWViewModel), true);
                                                            $('#valfactorerrorbulkupload').show();
                                                        }
                                                        else {
                                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "The file has been uploaded successfully.";
                                                            logger.logSuccess('Sheet uploaded successfully ', 'Success', system.getModuleId(OLWViewModel), true);
                                                            $('#valfactorerrorbulkupload').show();
                                                            GetOrgLevelWeightings();
                                                        }
                                                    }
                                                    else {
                                                        document.getElementById('valfactorerrorbulkupload').innerHTML = "The file could not be uploaded.";
                                                        logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(OLWViewModel), true);
                                                        $('#valfactorerrorbulkupload').show();
                                                        document.getElementById('FileUploader').value = null;
                                                    }
                                                }
                                                else
                                                    ajaxFail(request, "");
                                            }
                                        };

                                        request.upload.addEventListener('progress', function (event) {
                                            document.getElementById('valfactorerrorbulkupload').innerHTML = "Uploading File...";
                                        });
                                        request.withCredentials = true;
                                        request.open('POST', "/api/WeightingsThresholds/UploadOrganizationalLevelsBulkWeightingsExcelTemplate?RiskAreaType=" + OLWViewModel.RiskType().toString() + "&ratId=" + parseInt(OLWViewModel.AssessmentTypeId()) + "&OrgLevel=" + OLWViewModel.SelectedSubOrganizationLevel().toString() + "&ealId=" + data.selectedTaxonomyLevel.toString());

                                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                        var headers = appsecurity.getSecurityHeaders();
                                        headers.__RequestVerificationToken = csrfToken;
                                        request.setRequestHeader('Authorization', headers.Authorization);
                                        request.setRequestHeader('RT', headers.RT);
                                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                        request.send(FormDataObj);
                                    }
                                    else {
                                        document.getElementById('FileUploaderBulkUpload').value = null;
                                        logger.logError("Upload File Size cannot exceed " + (OLWViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.", 'Error', system.getModuleId(OLWViewModel), true);
                                    }
                                }
                                else {
                                    document.getElementById('FileUploaderBulkUpload').value = null;
                                    logger.logError('Please select valid File to Upload.', 'Error', system.getModuleId(OLWViewModel), true);
                                }
                            }
                            else {
                                document.getElementById('FileUploaderBulkUpload').value = null;
                                logger.logError('Please select a File to Upload', 'Error', system.getModuleId(OLWViewModel), true);
                            }
                            function ajaxFail(error, status) {
                                try {
                                    if (error.status == 401) {
                                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                            .then(function (option) {
                                                if (option == "OK")
                                                    router.navigate("survey/SurveyDashBoard", true);
                                            })
                                    }
                                    else {
                                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in BulkuploadOrganizationalWeightingsDocument() method in OrganizationalLevelWeightings.js';
                                        logger.logMessage(msg);
                                    }
                                } catch (e) {
                                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in BulkuploadOrganizationalWeightingsDocument() method in OrganizationalLevelWeightings.js';
                                    logger.logMessage(msg);
                                }
                            };
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in BulkuploadOrganizationalWeightingsDocument() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ----Weights Methods----

        function EditAreaWeights(data, event) {
            try {
                var curr = event.currentTarget.parentElement.children[0].id;
                setSelectedArea(curr);
                $("div.dataTables_scrollBody").animate({ scrollLeft: 0 }, 800);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: EditAreaWeights() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function saveWeights() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/SaveOrganizationalWeightings?AreaId=" + parseInt(OLWViewModel.selectedAreaId()) + "&riskareatype=" + OLWViewModel.RiskType() + "&AssessmentType=" + parseInt(OLWViewModel.AssessmentTypeId()) + "&OrgLevel=" + OLWViewModel.SelectedOrgLevel(),  //to save the bu level wieghtings.
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(OLWViewModel.WeightingsList(), function (item) {
                        return { BuId: item.BuId(), RiskAreaId: item.RiskAreaId(), WeightingValue: item.WeightingValue() };
                    }))
                })
                    .success(ajaxSuccessInherentWeights)
                    .fail(ajaxFailInherentWeights);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeights() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccessInherentWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                    else if (jsonResult != null && jsonResult != 0) {
                        logger.logSuccess('Organizational Weightings are saved successfully.', 'Success', system.getModuleId(OLWViewModel), true);
                        GetOrgLevelWeightings();
                    }
                    else {
                        logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeights() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailInherentWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeights() method in OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeights() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function AutoPopulateWeights(data, event) {
            try {
                $('#AutoPopulatePopup').modal('show');
                if (OLWViewModel.TaxonomyLevels() == undefined || OLWViewModel.TaxonomyLevels().length == 0)
                    GetTaxonomyLevels();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: AutoPopulateWeights() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function PopulateWeights(data, event) {
            try {
                if (OLWViewModel.radioSelectedOptionValue() === "0") {
                    PopulateWeightsEqual(data, event);
                }
                else {
                    PopulateWeightsRatioBased(data, event);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: PopulateWeights() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function PopulateWeightsEqual(data, event) {
            try {
                app.showMessage("Populating weights will delete existing configured weights at this level.Are you sure you would like to proceed?", "Warning", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                    .then(function (option) {
                        if (option == "Yes") {
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            $.ajax({
                                url: "/api/WeightingsThresholds/PopulateOrganizationalLevelWeights?AssessmentType=" + parseInt(OLWViewModel.AssessmentTypeId()) + "&RiskAreaType=" + OLWViewModel.RiskType() + "&OrgLevel=" + parseInt(data.SelectedOrganizationLevelText()) + "&AreaLevel=" + parseInt(data.selectedTaxonomyLevel),
                                headers: headers,
                                type: "POST",
                                contentType: 'application/json',
                                dataType: 'json'
                            })
                                .success(ajaxSuccessPopulateWeights)
                                .fail(ajaxFailPopulateWeights);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in PopulateWeightsEqual() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccessPopulateWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                    else if (jsonResult != null && jsonResult != "0") {
                        logger.logSuccess('Weightings are populated successfully.', 'Success', system.getModuleId(OLWViewModel), true);
                        GetOrgLevelWeightings();
                    }
                    else {
                        logger.logError('Some error occurred while populating.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in PopulateWeightsEqual() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailPopulateWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PopulateWeights() method in OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in PopulateWeightsEqual() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function PopulateWeightsRatioBased(data, event) {
            try {
                app.showMessage("Populating weights will delete existing configured weights at this level.Are you sure you would like to proceed?", "Warning", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                    .then(function (option) {
                        if (option == "Yes") {
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            $.ajax({
                                url: "/api/WeightingsThresholds/PopulateOrganizationalLevelWeightsRatioBased?AssessmentType=" + parseInt(OLWViewModel.AssessmentTypeId()) + "&RiskAreaType=" + OLWViewModel.RiskType() + "&OrgLevel=" + parseInt(data.SelectedOrganizationLevelText()) + "&AreaLevel=" + parseInt(data.selectedTaxonomyLevel) + "&SourceArea=" + parseInt(data.selectedSourceAreaLevel()),
                                headers: headers,
                                type: "POST",
                                contentType: 'application/json',
                                dataType: 'json'
                            })
                                .success(ajaxSuccessPopulateWeights)
                                .fail(ajaxFailPopulateWeights);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in PopulateWeightsRatioBased() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccessPopulateWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                    else if (jsonResult != null && jsonResult != "0") {
                        logger.logSuccess('Weightings are populated successfully.', 'Success', system.getModuleId(OLWViewModel), true);
                        GetOrgLevelWeightings();
                    }
                    else {
                        logger.logError('Some error occurred while populating.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in PopulateWeightsRatioBased() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailPopulateWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PopulateWeightsRatioBased() method in OrganizationalLevelWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in PopulateWeightsRatioBased() method in OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function applyOrgLevelWeightings() {
            try {
                if (OLWViewModel.FreezeFlag() == 1) {
                    app.showMessage('Are you sure you want to Apply Weightings for this Level, It will clear all previously saved values for different areas?', 'Apply Changes', ['Confirm', 'Cancel'], false, { primaryButtonClass: "mr-2 btn-curved fa fa-check btn btn-success autofocus", secondaryButtonClass: "mr-2 btn-curved fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-plus text-default' })
                        .then(function (option) {
                            if (option === 'Confirm') {
                                OrgLevelChangeClick();
                            }
                        });
                }
                else {
                    OrgLevelChangeClick();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: applyOrgLevelWeightings() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RefreshWeights() {
            try {
                GetOrgLevelWeightings();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RefreshWeights() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ----Copyover----

        function checkCopyOver() {
            app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please Deny. </b> ", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == 'Confirm') {
                        if (OLWViewModel.EditableAreaTotal() != OLWViewModel.UpperDecimalLimit()) {
                            logger.logError('The total for weightings should be 100.00000% ', 'Error', system.getModuleId(OLWViewModel), true);
                        }
                        else {
                            OLWViewModel.WeightingsList([]);
                            app.showMessage("Would you like to copy over same weights to all areas at the same level?", "Save/Copy Over", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                                .then(function (option) {
                                    if (option == 'Yes') {
                                        for (var j = 0; j < OLWViewModel.BusinessUnits().length; j++) {
                                            for (var i = 0; i < OLWViewModel.AreasOrQuestions().length; i++) {
                                                OLWViewModel.WeightingsList.push(new WeightingsModel({ BuId: OLWViewModel.BusinessUnits()[j].BUId(), RiskAreaId: OLWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: OLWViewModel.BusinessUnits()[j].selectedAreaWeight() }));
                                            }
                                        }
                                        saveWeights();
                                    }
                                    else {
                                        for (i = 0; i < OLWViewModel.BusinessUnits().length; i++) {
                                            OLWViewModel.WeightingsList.push(new WeightingsModel({ BuId: OLWViewModel.BusinessUnits()[i].BUId(), RiskAreaId: OLWViewModel.EditArea().AreaId(), WeightingValue: OLWViewModel.BusinessUnits()[i].selectedAreaWeight() }));
                                        }
                                        saveWeights();
                                    }
                                });
                        }
                    }
                });
        }

        //#endregion

        //#region ----Models----

        function OrganizationModel(item) {
            var self = this;
            self.OrgLevel = $('<div/>').html(item.Bulevel).text();
            self.OrgName = $('<div/>').html(item.BlName).text();
            self.OrgId = item.BlId;
        }

        function OrganizationLevelModel(item) {
            var self = this;
            self.BlName = $('<div/>').html(item.BlName).text();
            self.BlId = $('<div/>').html(item.BlId).text();
            self.PreviouslySelectedFlag = item.PreviouslySelectedFlag;
        }

        function SubOrganizationModel(item) {
            var self = this;
            self.SubOrgLevel = $('<div/>').html(item.BuLevelDetailId).text();
            self.SubOrgName = $('<div/>').html(item.BuLevelDetailName).text();
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (OLWViewModel.AreaLeveljstree()[self.id].length > 0 && item.DeadNode == 0) {
                self.nodes = $.map(OLWViewModel.AreaLeveljstree()[self.id], (result) => {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: true };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.BUId = ko.observable(item.BusinessUnitId);
                self.BUName = ko.observable(item.BusinessUnitName);
                if (item.BusinessUnitName.length > 18) {
                    self.BUShortName = ko.observable((item.BusinessUnitName).substring(0, 15) + '...');
                }
                else
                    self.BUShortName = ko.observable(item.BusinessUnitName);
                if (item.BUWeightings !== undefined && item.BUWeightings !== null) {
                    var MappedWeights = $.map(item.BUWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.BUWeightings = MappedWeights;
                }
                self.selectedAreaWeight = ko.observable(0);
                self.selectedAreaWeight.subscribe(function (newVal) {
                    if ($.isNumeric(newVal) && Number(newVal) >= OLWViewModel.LowerDecimalLimit() && Number(newVal) <= OLWViewModel.UpperDecimalLimit()) {
                        var total = 0;
                        for (var i = 0; i < OLWViewModel.BusinessUnits().length; i++) {
                            total += Number(Number(OLWViewModel.BusinessUnits()[i].selectedAreaWeight()));
                        }
                        OLWViewModel.EditableAreaTotal(total.toFixed(OLWViewModel.decimalLimit()));
                    }
                    else if ($.isNumeric(newVal) && (Number(newVal) < OLWViewModel.LowerDecimalLimit() || Number(newVal) > OLWViewModel.UpperDecimalLimit())) {
                        this.selectedAreaWeight(0);
                        logger.logError('Value should be in range of (0-100).', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                    else {
                        this.selectedAreaWeight(0);
                        logger.logError('Non-numeric values are not allowed.', 'Error', system.getModuleId(OLWViewModel), true);
                    }
                }, this);
                self.Applicability = ko.observable(0);
                self.Applicability.subscribe(function (newVal) {
                    this.Applicability(newVal);
                }, this);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function TaxonomyModel(item) {
            try {
                var self = this;
                self.LevelId = ko.observable(item.LevelId);
                self.LevelName = ko.observable(item.LevelName);
                self.isMaxLevel = ko.observable(item.isMaxLevel);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RiskAreaModel(item) {
            try {
                var self = this;
                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
                if (item.AreaName.length > 43) {
                    self.AreaShortName = ko.observable((item.AreaName).substring(0, 40) + '...');
                }
                else
                    self.AreaShortName = ko.observable(item.AreaName);
                if (item.AreaWeightings !== undefined && item.AreaWeightings !== null) {
                    var MappedWeights = $.map(item.AreaWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.AreaWeightings = MappedWeights;
                }
                self.total = ko.computed(function () {
                    var total = 0;
                    for (var p = 0; p < self.AreaWeightings.length; ++p) {
                        total += Number(Number(self.AreaWeightings[p].WeightingValue()));
                    }
                    return total.toFixed(OLWViewModel.decimalLimit());
                });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function WeightingsModel(item) {
            try {
                var self = this;
                self.BuId = ko.observable(item.BuId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.WeightingValue = ko.observable(item.WeightingValue);
                self.Applicability = ko.observable(item.Applicability);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WeightingsModel() method in OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        //#endregion
    });
